import React from 'react';

import { isMobileMedia } from 'bento-ordering/utils/media';

import MenuContainer from 'bento-ordering/menus/containers/MenuContainer';
import OrderSettingRoute from 'bento-ordering/menus/containers/OrderSettingRoute';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

/**
 * This container follows the same pattern as LocationDetailContainer.
 * If this is on mobile, we are displaying the LocationDetailRoute as
 * a page else we will render the menu container and render a
 * LocationDetailModal on top of the menu.
 */
class OrderSettingRouteContainer extends React.Component {
  render() {
    if (isMobileMedia()) {
      return <OrderSettingRoute />;
    } else {
      return <MenuContainer shouldOpenOrderSettingModal />;
    }
  }
}

export default withGoogleLibraryLoaded(OrderSettingRouteContainer);
